import { CREATE_STORE, LIST_OF_STORE, STORE } from "./ApiRoutes";
import { authData } from "./services";

export const listOfStore = async (data: object) => {
  const response = await authData.post(LIST_OF_STORE, data);
  return response?.data;
};

export const createStore = async (data: object) => {
  const response = await authData.post(CREATE_STORE, data);
  return response?.data;
};

export const deleteStore = async (id: number) => {
  const response = await authData.delete(`${STORE}${id}`);
  return response?.data;
};

export const editStore = async (id: number, data: object) => {
  const response = await authData.put(`${STORE}${id}`, data);
  return response?.data;
};

export const viewStore = async (id: number) => {
  const response = await authData.get(`${STORE}${id}`);
  return response?.data;
};
